/**
 * BELLE AURA — colonne de navigation latérale
 *
 * Panneau ouvert par le déclencheur « 3 traits ». Sans dépendance, sans
 * interférence avec les composants natifs du thème Horizon.
 *
 * Accessibilité : aria-expanded sur le bouton, `inert` sur le panneau fermé
 * (le contenu masqué sort du parcours clavier et des lecteurs d'écran),
 * piège de focus, fermeture par Échap, restitution du focus au bouton.
 */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init() {
    var trigger = document.querySelector('[data-ba-open-button]');
    var panel = document.getElementById('ba-nav');
    var scrim = document.querySelector('.ba-nav-scrim');

    if (!trigger || !panel) return;

    var headerSlot = document.querySelector('.header__column--left');
    if (!headerSlot) return;
    headerSlot.prepend(trigger);
    trigger.setAttribute('aria-label', 'Ouvrir le menu');
    var label = trigger.querySelector('.ba-trigger__label');
    if (label) label.remove();

    var root = document.documentElement;
    var isOpen = false;
    var lastFocused = null;

    // Le panneau est masqué au repos : `inert` si le navigateur le connaît,
    // sinon repli sur aria-hidden.
    function setInert(state) {
      if ('inert' in HTMLElement.prototype) {
        panel.inert = state;
      } else {
        panel.setAttribute('aria-hidden', state ? 'true' : 'false');
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;

      root.setAttribute('data-ba-nav', 'open');
      trigger.setAttribute('aria-expanded', 'true');
      setInert(false);
      if (scrim) scrim.hidden = false;

      // Le focus part sur le premier élément du panneau une fois la
      // transition amorcée, sinon le navigateur annule le défilement.
      window.requestAnimationFrame(function () {
        var first = panel.querySelector(FOCUSABLE);
        if (first) first.focus();
      });
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;

      root.removeAttribute('data-ba-nav');
      trigger.setAttribute('aria-expanded', 'false');
      setInert(true);

      // Le voile reste dans le DOM le temps du fondu, puis se retire.
      if (scrim) {
        window.setTimeout(function () {
          if (!isOpen) scrim.hidden = true;
        }, 500);
      }

      if (returnFocus !== false && lastFocused && lastFocused.focus) {
        lastFocused.focus();
      }
    }

    function toggle() {
      if (isOpen) close();
      else open();
    }

    // Piège de focus : Tab tourne en boucle à l'intérieur du panneau ouvert.
    function trapFocus(event) {
      if (event.key !== 'Tab' || !isOpen) return;

      var items = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) {
          return el.offsetParent !== null;
        }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    trigger.addEventListener('click', toggle);

    document.querySelectorAll('[data-ba-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        event.preventDefault();
        close();
      }
      trapFocus(event);
    });

    // Suivre un lien ferme le panneau sans lui rendre le focus : la page
    // suivante doit démarrer sur son propre contenu.
    panel.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link) close(false);
    });

    // Retour arrière depuis le cache navigateur : on repart fermé.
    window.addEventListener('pageshow', function () {
      close(false);
    });

    // État initial explicite.
    setInert(true);
    trigger.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    trigger.hidden = false;
    panel.hidden = false;

    // Signale que la navigation Belle Aura a pris la main. La feuille de style
    // ne masque le hamburger natif du thème sur mobile que sous ce drapeau :
    // si ce script échoue, le menu d'origine reste disponible.
    root.setAttribute('data-ba-ready', '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
